import loadBuffer from './load-buffer';

export const loadString = async (): Promise<string> => {
    const
        buffer = await loadBuffer(),
        decoder = new TextDecoder();
    return decoder.decode(buffer);
};
